import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface ProfessionnelObjectifsStepProps {
  onComplete: (data: { objectif: string }) => void;
}

export const ProfessionnelObjectifsStep = ({ onComplete }: ProfessionnelObjectifsStepProps) => {
  const [autreObjectif, setAutreObjectif] = useState('');

  const objectifs = [
    'Cohésion d\'équipe',
    'Networking',
    'Présentation / lancement',
    'Célébration interne',
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        {objectifs.map((objectif) => (
          <Button
            key={objectif}
            onClick={() => onComplete({ objectif })}
            variant="outline"
            className="h-12"
          >
            {objectif}
          </Button>
        ))}
      </div>
      
      <div className="space-y-2">
        <Input
          placeholder="Autre (précisez)"
          value={autreObjectif}
          onChange={(e) => setAutreObjectif(e.target.value)}
        />
        <Button
          onClick={() => onComplete({ objectif: autreObjectif })}
          disabled={!autreObjectif.trim()}
          variant="outline"
          className="w-full"
        >
          Valider "Autre"
        </Button>
      </div>
    </div>
  );
};